import * as angular from 'angular';

"use strict";

angular.module('BlocworxModule')
       .controller('isIframeController', IsIframeController);

IsIframeController.$inject = ['$scope', 'ScopeAndLocal'];

// Controller Constructor
function IsIframeController($scope, ScopeAndLocal) {

    // Creating the view model reference
    let vm = this;

    /**
     * Constructor class.
     */
    vm.$onInit = function () {
        try {

        } catch (e) {
            console.log(e);
        }
    }
}

export default IsIframeController;